// 공통 에러 상태 — fetch 실패 + placeholderData도 없을 때만 노출
// retry 버튼은 react-query refetch 콜백 받음

import { ApiError } from "../../lib/api";
import { CSIcon } from "../../redesign/_components/cs";
import { NetworkHint } from "./NetworkHint";

interface Props {
  error: unknown;
  onRetry?: () => void;
}

function describe(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 401 || error.status === 403) return "로그인이 필요해요.";
    if (error.status === 429) return "잠시 후 다시 시도해 주세요.";
    if (error.status >= 500) return "서버 점검 중일 수 있어요.";
    return `요청 실패 (${error.status})`;
  }
  if (error instanceof Error) return error.message;
  return "알 수 없는 오류가 발생했어요.";
}

export function ErrorState({ error, onRetry }: Props) {
  return (
    <div
      style={{
        padding: "48px 16px",
        textAlign: "center",
        color: "var(--cs-mute)",
        fontSize: 14,
        lineHeight: 1.6,
      }}
      role="alert"
    >
      <div aria-hidden style={{ marginBottom: 8 }}>
        <CSIcon name="warning" size={32} color="var(--cs-alert, #E54B25)" />
      </div>
      <div style={{ marginBottom: 16 }}>{describe(error)}</div>
      {/* 전면 실패로 판정될 때만 노출 — VPN·DNS 앱 후킹 안내 */}
      <NetworkHint style={{ marginTop: -6 }} />
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          style={{
            minHeight: 44,
            padding: "0 20px",
            border: "1px solid var(--cs-line)",
            background: "var(--cs-surface)",
            color: "var(--cs-ink)",
            borderRadius: 8,
            fontSize: 14,
            cursor: "pointer",
          }}
        >
          다시 시도
        </button>
      )}
    </div>
  );
}
